import Sangria from "@/Pages/Caixas/sangria.vue";

export default [
  {
    path: "/sangria",
    name: "sangria",
    component: Sangria,
  },
];
